import { getShortcutsByProject } from '@gonfalon/openapi/operations/getShortcutsByProject';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const shortcuts = createQueryKeys('shortcuts', {
  list: ({ projectKey }: { projectKey: string }) => ({
    queryKey: [projectKey],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getShortcutsByProject({ projectKey }, { signal })),
  }),
});

export const shortcutsList = shortcuts.list;
